import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./TimeTableTeacherDetails.css";
import { formatTime } from "../../../../../Components/FormatTime/FormatTime";

class TimeTableTeacherDetails extends Component {
  render() {
    const { classes, timeData } = this.props;
    return (
      <Grid item xs={12} sm={6} md={3} xl={3} lg={3}>
        <Paper elevation={3} className={classes.root}>
          <div>
            {timeData.studentClass} - {timeData.section}
          </div>
          {timeData.faculty && timeData.group && (
            <div>
              {timeData.faculty} - {timeData.group}
            </div>
          )}
          <div style={{ display: "flex" }}>
            ({formatTime(timeData.from)} - {formatTime(timeData.to)})
          </div>
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(TimeTableTeacherDetails);
